<div class="container-fluid well">
  <div class="row">
    <div class="col-xs-12">
      @if (displayInsetLots()) {
        <div
          class="inset-lots">
          <div class="row height30 pb20">
            <div class="col-md-9 h5">Inset Lots</div>
            <div class="col-xs-4">
              <label class="control-label required-input">Does the plan contain inset lots?</label>
              <div class="input-group">
                @for (option of insetLotsValues; track option; let isLast = $last) {
                  <label
                    class="nlr-radio"
                    [class.has-radio-error]="insetLots | formFieldHasError">
                    <input
                      type="radio"
                      name="insetLots"
                      required
                      min="0"
                      (change)="insetLotsChanged()"
                      [disabled]="!option.active || isDisabled()"
                      [value]="option.value"
                      [(ngModel)]="getModel().insetLots"
                      #insetLots="ngModel" />
                    <span>{{option.displayValue}}</span>
                  </label>
                }
              </div>
            </div>
            @if (getModel().insetLots) {
              <div
                class="col-xs-4">
                <label class="control-label required-input">Number of inset lots</label>
                <div
                  class="input-group"
                  [ngClass]="{'has-error': numberOfInsetLots | formFieldHasError}">
                  <span class="input-group-addon">
                    <i class="nlrp-icon nlrp-icon-edit"></i>
                  </span>
                  <input
                    type="number"
                    name="numberOfInsetLots"
                    id="numberOfInsetLots"
                    class="form-control"
                    placeholder="Enter Number of Inset Lots"
                    min="1"
                    pattern="\d*"
                    required
                    (input)="onNumberOfInsetLotsInput($event)"
                    [disabled]="isDisabled()"
                    [(ngModel)]="getModel().numberOfInsetLots"
                    #numberOfInsetLots="ngModel" />
                </div>
                @if (numberOfInsetLots | formFieldHasError) {
                  <div
                    class="help-block">
                    <span>Error!</span>
                    <span>Number of inset lots must be a positive whole number.</span>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }

      <div class="row height30">
        <div class="col-md-9 h5">{{title}}</div>
      </div>

      <table class="table table-hover fee-table">
        <thead>
          <tr class="default">
            <td
              title="The description of the product">
              Product Description
            </td>
            <td
              class="text-right"
              title="The quantity of each product">
              Quantity
            </td>
            <td
              class="text-right"
              title="The unit price of each product">
              Unit Price
            </td>
            <td
              class="text-right"
              title="The sum of quantity and unit price in dollars">
              Sub-Total
            </td>
          </tr>
        </thead>
        <tbody>
          @for (feeSummary of feeSummaries; track $index) {
            <tr>
              <td>{{feeSummary.description}}</td>
              <td class="text-right">{{feeSummary.quantity}}</td>
              <td class="text-right">${{feeSummary.baseAmount}}</td>
              <td class="text-right">${{feeSummary.total}}</td>
            </tr>
          }
        </tbody>
      </table>
      <div>
        <label class="total-position">
          Total
          <input
            readonly="readonly"
            class="form-inline inputBox white text-right"
            value="${{getTotalDue()}}"
            type="text"
            title="The total cost of all products in dollars" />
        </label>
      </div>

      @if (showAdditionalSheetFeeStatement()) {
        <div>
          <i class="nlrp-icon nlrp-icon-error fee-info"></i>
          <span>Additional sheet fees may apply and will be processed manually.</span>
        </div>
      }

      @if (showAdditionalParcelFeeStatement()) {
        <div>
          <i class="nlrp-icon nlrp-icon-error fee-info"></i>
          <span>Additional parcel fees may apply and will be processed manually.</span>
        </div>
      }

      @if (getZeroChargeableLotsMessage()) {
        <div>
          <i class="nlrp-icon nlrp-icon-error fee-info"></i>
          <span>{{getZeroChargeableLotsMessage()}}</span>
        </div>
      }
    </div>
  </div>
</div>
